/* eslint-disable import/prefer-default-export */

export const SKIP_REASONS_MAP = {
  DIFFICULT_QUESTION: 'Difficult Question',
  DIDNT_UNDERSTAND: "Didn't Understand",
  HAVENT_STUDIED: "Haven't studied"
};
